module.exports = __webpack_public_path__ + "img/img87.00798c32.svg";